/**
 * Normalise les erreurs techniques (Supabase, fetch, Error) en message FR lisible.
 * Ne doit jamais afficher de SQL brut à l’utilisateur.
 */
export function toUserMessage(err: unknown, fallback = "Une erreur est survenue. Réessayez dans un instant."): string {
  if (err == null) return fallback;
  if (typeof err === "string") {
    const t = err.trim();
    return t ? mapKnownPhrases(t) : fallback;
  }

  let raw = "";
  if (err instanceof Error && err.message) {
    raw = err.message;
  } else {
    try {
      const o = err as { message?: string; error_description?: string; hint?: string };
      raw = (typeof o.message === "string" && o.message) || (typeof o.error_description === "string" && o.error_description) || "";
    } catch {
      raw = "";
    }
  }

  const msg = raw.trim();
  if (!msg) return fallback;

  const lower = msg.toLowerCase();

  if (lower.includes("failed to fetch") || lower.includes("networkerror") || lower.includes("load failed")) {
    return "Problème de connexion. Vérifiez votre réseau puis réessayez.";
  }
  if (lower.includes("aborted") || lower.includes("abort")) {
    return "Opération annulée ou expirée.";
  }
  if (lower.includes("jwt") || lower.includes("session") || lower.includes("not authenticated") || lower.includes("401")) {
    return "Session expirée ou non autorisée. Reconnectez-vous.";
  }
  if (lower.includes("permission denied") || lower.includes("rls") || lower.includes("42501") || lower.includes("403")) {
    return "Action refusée. Vérifiez les droits de votre compte ou de la boutique.";
  }
  if (lower.includes("unique") || lower.includes("duplicate") || lower.includes("23505") || lower.includes("already exists")) {
    return "Cette valeur existe déjà (doublon). Modifiez le nom ou l’identifiant.";
  }
  if (lower.includes("foreign key") || lower.includes("23503")) {
    return "Référence invalide ou élément lié introuvable.";
  }
  if (lower.includes("violates check constraint") || lower.includes("23514")) {
    return "Données invalides pour un des champs. Vérifiez les montants ou les valeurs autorisées.";
  }
  if (lower.includes("timeout") || lower.includes("timed out")) {
    return "Délai dépassé. Réessayez dans un instant.";
  }

  return mapKnownPhrases(msg);
}

function mapKnownPhrases(msg: string): string {
  const lower = msg.toLowerCase();
  if (lower.includes("aucun magasin actif")) return msg;
  if (lower.includes("magasin")) return msg.length < 200 ? msg : "Erreur liée à la boutique. Réessayez ou contactez le support.";
  return msg.length > 220 ? "Une erreur est survenue. Réessayez ou contactez le support si le problème continue." : msg;
}
